// Re-exports from unified color system
import { PRIMITIVE_COLORS, SEMANTIC_COLORS } from '../residentColors';

export const ACCOUNT_COLORS = {
  background: SEMANTIC_COLORS.background.primary,
  contentBackground: SEMANTIC_COLORS.background.secondary,
  navActiveBackground: PRIMITIVE_COLORS.resioBlue,
  outerBorder: PRIMITIVE_COLORS.resioBlueBorder,
  innerBorder: PRIMITIVE_COLORS.gray700,
  divider: PRIMITIVE_COLORS.gray700,
  textPrimary: SEMANTIC_COLORS.text.primary,
  textSecondary: PRIMITIVE_COLORS.gray400,
  textMuted: PRIMITIVE_COLORS.gray500,
  avatarBackground: PRIMITIVE_COLORS.white10,
  buttonOutline: SEMANTIC_COLORS.text.primary,
  buttonPrimary: PRIMITIVE_COLORS.resioBlue,
  chevronColor: SEMANTIC_COLORS.text.primary,
} as const;
